<template>
  <nav class="navigation-bar">

    <el-menu theme="dark" :default-active="defaultRoute.name" mode="horizontal" :router="true">

      <li class="brand"><router-link to="/">{{ $t('ulockme') }}</router-link></li>

      <!-- Routes -->

      <template v-for="route in routes">

        <el-submenu
          v-if="route.routes"
          :index="route.name" >

          <template slot="title">{{ $t('nav.' + route.name) }}</template>

          <el-menu-item
            v-for="route in route.routes"
            :route="route"
            :index="route.name">{{ $t('nav.' + route.name) }}</el-menu-item>

        </el-submenu>

        <el-menu-item
          v-else
          :route="route"
          :index="route.name">{{ $t('nav.' + route.name) }}</el-menu-item>

      </template>

      <!-- Logout -->

      <el-menu-item
        @click.native="logout"
        index="logout"
        class="right">{{ $t('nav.logout') }}</el-menu-item>

      <!-- Languages -->

      <el-submenu index="lang" class="right">
        <template slot="title">{{ $t('nav.' + 'changeLanguage') }}</template>

        <el-menu-item
          @click.native="changeLang('hu')"
          :route="currentRoute"
          :index="currentRoute.name">{{ $t('lang.hungarian') }}</el-menu-item>

        <el-menu-item
          @click.native="changeLang('en')"
          :route="currentRoute"
          :index="currentRoute.name">{{ $t('lang.english') }}</el-menu-item>

      </el-submenu>

    </el-menu>

  </nav>
</template>

<script>
import Vue from 'vue'
import { LOGIN } from 'router/routes'
import auth from 'providers/auth'
import locale from 'element-ui/lib/locale'

export default {
  name: 'navigation-bar',
  data () {
    return {
      defaultRoute: this.$route
    }
  },
  computed: {
    routes () {
      const routes = []

      this.$router.options.routes
        .filter(this._showItem)
        .forEach(route => {
          if (route.meta && route.meta.group) {
            let submenu = routes.find(r => r.name === route.meta.group)

            if (!submenu) {
              submenu = { name: route.meta.group, routes: [] }
              routes.push(submenu)
            }

            submenu.routes.push(route)
          }
          else {
            routes.push(route)
          }
        })

      return routes
    },
    currentRoute () {
      return Object.assign({}, this.$route)
    }
  },
  methods: {
    logout () {
      auth.logout()
      this.$router.push({ name: LOGIN })
    },
    changeLang (lang) {
      Vue.config.lang = lang
      locale.use(lang)

      window.localStorage.lang = lang
    },
    _showItem ({meta = {}}) {
      if (meta.hideFromNav) {
        return false
      }

      if (meta.hideWhenLoggedIn && this.loggedIn) {
        return false
      }

      if (meta.permission && !this.hasPermission(meta.permission)) {
        return false
      }

      return true
    }
  }
}
</script>

<style lang="scss">
.navigation-bar {
  position: fixed;
  width: 100%;
  z-index: 9998;

  .brand {
    font-size: 1.5em;
    float: left;
    height: 60px;
    line-height: 60px;
    margin: 0;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    border-bottom: 5px solid transparent;
    padding: 0 20px;

    a,
    a:link,
    a:active,
    a:visited,
    a:hover {
      text-decoration: none;
    }
  }

  ul.el-menu {
    border-radius: 0 !important;
  }

  .right {
    float: right !important;

    .el-submenu__title {
      border-bottom: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// NavigationBar.vue?7ce61a99